import React, { useEffect, useState } from "react";
import { PageBody, PageHeader } from "@/components/AppLayout";
import { History } from "lucide-react";
import api from "@/lib/api";

export default function AuditLogs() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/api/audit-log").then((r) => setRows(r.data)); }, []);
  return (
    <>
      <PageHeader title="Audit Log" subtitle="Every action, every actor, every timestamp. Forever." />
      <PageBody>
        <div className="rounded-xl border border-border bg-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="text-[11px] uppercase tracking-wider text-muted-foreground bg-accent/30">
              <tr><th className="text-left px-4 py-3">When</th><th className="text-left px-4 py-3">Actor</th><th className="text-left px-4 py-3">Action</th><th className="text-left px-4 py-3">Target</th><th className="text-left px-4 py-3">Note</th></tr>
            </thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={5} className="py-10 text-center text-muted-foreground"><History size={28} className="mx-auto mb-2 opacity-30" /> No events yet.</td></tr>}
              {rows.map((e) => (
                <tr key={e.id} className="border-t border-border/50" data-testid={`audit-${e.id}`}>
                  <td className="px-4 py-2.5 text-xs text-muted-foreground tabular-nums">{e.created_at ? new Date(e.created_at).toLocaleString() : "—"}</td>
                  <td className="px-4 py-2.5">{e.actor_name || "system"}</td>
                  <td className="px-4 py-2.5 font-mono text-xs">{e.action}</td>
                  <td className="px-4 py-2.5 font-mono text-xs">{e.target}</td>
                  <td className="px-4 py-2.5 text-xs text-muted-foreground">{e.note || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </PageBody>
    </>
  );
}
